var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "brands" },
    [
      _c("div", { staticClass: "title" }, [_c("custom-breadcrumb")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "brands-search" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.brandsForm } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Brand Ownership", clearable: "" },
                      on: { change: _vm.search },
                      model: {
                        value: _vm.brandsForm.brandOwnerShip,
                        callback: function($$v) {
                          _vm.$set(_vm.brandsForm, "brandOwnerShip", $$v)
                        },
                        expression: "brandsForm.brandOwnerShip"
                      }
                    },
                    _vm._l(_vm.drop.ownerShip, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Shipping Fee", clearable: "" },
                      on: { change: _vm.search },
                      model: {
                        value: _vm.brandsForm.shippingFree,
                        callback: function($$v) {
                          _vm.$set(_vm.brandsForm, "shippingFree", $$v)
                        },
                        expression: "brandsForm.shippingFree"
                      }
                    },
                    _vm._l(_vm.drop.shoppingFee, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Status", clearable: "" },
                      on: { change: _vm.search },
                      model: {
                        value: _vm.brandsForm.brandStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.brandsForm, "brandStatus", $$v)
                        },
                        expression: "brandsForm.brandStatus"
                      }
                    },
                    _vm._l(_vm.drop.status, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input-with-select",
                      staticStyle: { width: "505px" },
                      attrs: { placeholder: "Brands Name" },
                      model: {
                        value: _vm.brandsForm.keyWords,
                        callback: function($$v) {
                          _vm.$set(_vm.brandsForm, "keyWords", $$v)
                        },
                        expression: "brandsForm.keyWords"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-input__icon el-icon-search",
                        attrs: { slot: "prefix" },
                        slot: "prefix"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "brands-search-button",
                          attrs: { slot: "append" },
                          on: { click: _vm.search },
                          slot: "append"
                        },
                        [_vm._v("\n          Search\n        ")]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "brands-content" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, stripe: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "Brand Name",
                  "min-width": "200",
                  fixed: "",
                  width: "280"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "table-brand" }, [
                          _c("div", { staticClass: "table-brand-img" }, [
                            _c("img", {
                              attrs: { src: scope.row.banner, alt: "" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "table-brand-text" }, [
                            _c("div", [_vm._v(_vm._s(scope.row.brandName))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.id) +
                                    "\n                "
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-copy-document copy-text",
                                  staticStyle: {
                                    color: "#84C5F9",
                                    "margin-left": "2px"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.copy($event, scope.row.id)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n                   " +
                                  _vm._s(scope.row.companyName) +
                                  "\n              "
                              )
                            ])
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Products", fixed: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", { staticStyle: { color: "#007AFF" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.productNum) +
                              "\n          "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Founded Time",
                  prop: "foundedTime",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Shipping Fee", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.shippingFree == 1
                                ? "free shipping"
                                : "non free"
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Brand Ownership", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.brandOwnerShip
                                ? "Brand Owner"
                                : "Brand Agent"
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Create Time",
                  prop: "createTime",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Supplier", prop: "supplier" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Reviewer / Review time", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.reviewer))]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(scope.row.reviewTime))])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Preview link", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "table-url",
                            on: {
                              click: function($event) {
                                return _vm.openUrl(scope)
                              }
                            }
                          },
                          [_vm._v("View")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: {
          currentPage: _vm.paging.current,
          total: _vm.paging.total,
          pageSize: _vm.paging.size
        },
        on: {
          handleSizeChange: _vm.handleSizeChange,
          handleCurrentChange: _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74640c5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74640c5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/brands/index.vue
// module id = L1GN
// module chunks = 2